import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FaArrowLeft } from 'react-icons/fa';
import styles from './andersoncruz_personal_consultoriapremium.module.scss';
import WhatsappIcon from '../../icons/whatsappIcon.tsx';

const WHATSAPP_NUMBER = '5517981132120';

const wa = (text: string) =>
    `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(text)}`;

const MSG_BRONZE =
    'Olá, Anderson! Quero saber mais sobre a Consultoria Online Premium no plano Bronze (1 aula presencial no mês, a partir de R$ 150,00/mês). Podemos conversar?';
const MSG_PRATA =
    'Olá, Anderson! Tenho interesse no plano Prata da Consultoria Online Premium (2 aulas presenciais no mês, a partir de R$ 199,90/mês). Podemos alinhar?';
const MSG_OURO =
    'Olá, Anderson! Quero a experiência completa no plano Ouro da Consultoria Online Premium (3 aulas presenciais no mês, a partir de R$ 249,00/mês). Podemos conversar?';
const MSG_GERAL =
    'Olá, Anderson! Vi a Consultoria Online Premium e quero entender qual plano (Bronze, Prata ou Ouro) combina melhor comigo. Podemos conversar?';

const Andersoncruz_personal_consultoriapremium: React.FC = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className={styles.andersoncruz_personal_consultoriapremium}>
            <div className={styles.page}>
                <header className={styles.header}>
                    <Link
                        to="/andersoncruz_personal"
                        state={{ skipLoader: true }}
                        className={styles.backButton}
                        aria-label="Voltar ao cartão digital"
                    >
                        <FaArrowLeft />
                    </Link>
                    <div className={styles.headerText}>
                        <p className={styles.eyebrow}>Anderson Cruz</p>
                        <h1 className={styles.title}>Consultoria On-line Premium</h1>
                    </div>
                </header>

                <p className={styles.intro}>
                    A praticidade da consultoria online com o poder das aulas presenciais estratégicas aos sábados, para
                    evoluir com mais segurança, execução impecável e resultados que se sustentam no tempo.
                </p>

                <div className={styles.contentFlow}>
                    <section className={styles.section} aria-labelledby="premium-sobre-heading">
                        <h2 id="premium-sobre-heading" className={styles.sectionTitle}>
                            O que é a premium?
                        </h2>
                        <p className={styles.prose}>
                            A Consultoria Online Premium foi criada para quem deseja unir a praticidade do
                            acompanhamento online com a experiência e os benefícios do acompanhamento presencial.
                        </p>
                        <p className={styles.prose}>
                            Além de toda a estrutura da consultoria online, com treino personalizado, aplicativo com vídeos
                            reais, avaliação física, check-ins e suporte profissional, você também tem acesso a aulas
                            presenciais exclusivas aos sábados, conforme o plano escolhido.
                        </p>
                        <p className={styles.prose}>
                            Ideal para quem quer evoluir com mais segurança, lapidar a execução e usar encontros
                            presenciais para acelerar resultados.
                        </p>
                    </section>

                    <section className={styles.section} aria-labelledby="diferencial-heading">
                        <h2 id="diferencial-heading" className={styles.sectionTitle}>
                            O grande diferencial: aulas aos sábados
                        </h2>
                        <p className={styles.prose}>
                            As aulas presenciais elevam a qualidade do seu treino. Você leva para o dia a dia o que
                            funciona de verdade na execução, com correção em tempo real e foco na sua biomecânica.
                        </p>
                        <ul className={styles.bulletList}>
                            <li>Correções em tempo real e ajustes técnicos imediatos</li>
                            <li>Mais intensidade e motivação para treinar no seu melhor</li>
                            <li>Aprendizado da execução correta, reduzindo erros que atrasam resultados</li>
                            <li>Ajustes individualizados para limitações, postura e mobilidade</li>
                            <li>Espaço para tirar dúvidas sobre execução, cargas, técnicas e progressão</li>
                        </ul>
                        <p className={styles.prose}>
                            Treine com mais tranquilidade sabendo que existe um profissional observando cada detalhe
                            quando isso mais importa.
                        </p>
                    </section>

                    <div className={styles.highlightBox}>
                        <h2 className={styles.highlightTitle}>Mais do que um treino</h2>
                        <p className={styles.prose}>
                            A Consultoria Online Premium entrega resultado com estratégia, individualização e
                            acompanhamento de verdade. Você não recebe apenas um treino pronto: recebe um planejamento
                            pensado para a sua realidade, seus objetivos e a sua evolução.
                        </p>
                    </div>

                    <section className={styles.pricingSection} aria-labelledby="planos-premium-heading">
                        <h2 id="planos-premium-heading" className={styles.pricingTitle}>
                            Planos disponíveis
                        </h2>

                        <div className={styles.planCard}>
                            <p className={styles.planName}>Plano Bronze</p>
                            <p className={styles.planPeriod}>A partir de R$ 150,00 mensal</p>
                            <p className={styles.planPrice}>
                                Para quem quer consultoria online profissional e ainda contar com encontros presenciais
                                estratégicos.
                            </p>
                            <p className={styles.planPrice}>
                                <strong>Inclui:</strong> todos os benefícios da consultoria online +{' '}
                                <strong>1 aula presencial no mês</strong>.
                            </p>
                            <a
                                href={wa(MSG_BRONZE)}
                                className={styles.planWhatsapp}
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <WhatsappIcon height="18" color="#ffffff" />
                                <span>Quero o plano Bronze</span>
                            </a>
                        </div>

                        <div className={styles.planCard}>
                            <p className={styles.planName}>Plano Prata</p>
                            <p className={styles.planPeriod}>A partir de R$ 199,90 mensal</p>
                            <p className={styles.planPrice}>
                                Perfeito para quem busca acompanhamento mais próximo e maior frequência de correções
                                presenciais.
                            </p>
                            <p className={styles.planPrice}>
                                <strong>Inclui:</strong> todos os benefícios da consultoria online +{' '}
                                <strong>2 aulas presenciais no mês</strong>.
                            </p>
                            <a
                                href={wa(MSG_PRATA)}
                                className={styles.planWhatsapp}
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <WhatsappIcon height="18" color="#ffffff" />
                                <span>Quero o plano Prata</span>
                            </a>
                        </div>

                        <div className={styles.planCard}>
                            <p className={styles.planName}>Plano Ouro</p>
                            <p className={styles.planPeriod}>A partir de R$ 249,00 mensal</p>
                            <p className={styles.planPrice}>
                                A experiência mais completa: acompanhamento ainda mais próximo e estratégico.
                            </p>
                            <p className={styles.planPrice}>
                                <strong>Inclui:</strong> todos os benefícios da consultoria online +{' '}
                                <strong>3 aulas presenciais no mês</strong>.
                            </p>
                            <a
                                href={wa(MSG_OURO)}
                                className={styles.planWhatsapp}
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <WhatsappIcon height="18" color="#ffffff" />
                                <span>Quero o plano Ouro</span>
                            </a>
                        </div>
                    </section>
                </div>

                <p className={styles.footerNote}>
                    Valores e frequência de aulas presenciais podem ser confirmados no atendimento. Vagas para sábados
                    podem variar conforme agenda.
                </p>

                <div className={styles.ctaSection} aria-labelledby="cta-premium-heading">
                    <h2 id="cta-premium-heading" className={styles.ctaHeading}>
                        Quer a consultoria online com o “plus” presencial?
                    </h2>
                    <p className={styles.ctaText}>
                        Me diga seu objetivo e sua disponibilidade aos sábados. Eu te indico o plano que entrega o melhor
                        custo-benefício para a sua evolução: Bronze, Prata ou Ouro.
                    </p>
                    <a
                        href={wa(MSG_GERAL)}
                        className={styles.ctaWhatsapp}
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <WhatsappIcon height="22" color="#ffffff" />
                        <span>Falar com o Anderson</span>
                    </a>
                </div>
            </div>
        </div>
    );
};

export default Andersoncruz_personal_consultoriapremium;
